module.exports = {"411422100":"长岗镇","411422101":"平岗镇","411422102":"周堂镇","411422103":"蓼堤镇","411422104":"西陵寺镇","411422105":"城关镇","411422106":"潮庄镇","411422107":"尚屯镇","411422200":"后台乡","411422202":"河集乡","411422203":"孙聚寨乡","411422204":"白楼乡","411422205":"河堤乡","411422206":"白庙乡","411422207":"胡堂乡","411422208":"尤吉屯乡","411422210":"董店乡","411422211":"涧岗乡","411422213":"匡城乡","411422214":"城郊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411422.json
// module id = 1512
// module chunks = 0